import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonusImages, bonusTools } from '../data/bonus';
export function BonusPack() {
  return <section className="cube-grid border-t border-white/10 bg-navy-600" data-id="element-15" data-mp="1feqnys5eiuyx">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-16" data-mp="1t5m1wiurc29d">
        <div className="max-w-2xl" data-id="element-17" data-mp="1odc6inavi9zp">
          <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-18" data-mp="1ocatwee7lffv">
            Bonus Pack
          </p>
          <h2 className="mt-3 text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-19" data-mp="234l1lbxjonk8">
            Progress Feels Better When Learners Can See It.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-20" data-mp="2c2n82701s8ew">
            The included Bonus Pack makes progress visible with practical tools
            that help build momentum and make routines easier to sustain.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-start lg:gap-10" data-id="element-21" data-mp="dovfb9jocp62">
          <div className="grid gap-4 sm:grid-cols-2" data-id="element-22" data-mp="1g63ireazqqxk">
            <figure className="border border-white/10 bg-navy-800 p-3" data-id="element-23" data-mp="1g3hafcga07ea">
              <img src={bonusImages.questMap} alt="Printable Quest Map progress sheet from the Bonus Pack" className="block w-full" data-id="element-24" data-mp="1l4ybp92o9vve" />
              <figcaption className="pt-3 font-pixel text-[10px] uppercase tracking-[0.1em] text-white" data-id="element-25" data-mp="1uvsv85ojahd5">
                Quest Map
              </figcaption>
            </figure>
            <figure className="border border-white/10 bg-navy-800 p-3" data-id="element-26" data-mp="23tv57aq8wkck">
              <img src={bonusImages.rewardCards} alt="Printable cut-and-collect Reward Cards sheet from the Bonus Pack" className="block w-full" data-id="element-27" data-mp="28u94a39vcjyg" />
              <figcaption className="pt-3 font-pixel text-[10px] uppercase tracking-[0.1em] text-white" data-id="element-28" data-mp="eghyxfykom8t">
                Reward Cards
              </figcaption>
            </figure>
          </div>

          <div className="border border-white/10 bg-navy-900 p-5 sm:p-6" data-id="element-29" data-mp="bdtvhko7jhl8">
            <h3 className="font-pixel text-[11px] uppercase tracking-[0.1em] text-brand-emerald" data-id="element-30" data-mp="7cruozen6xh5">
              Included printable extras
            </h3>
            <ul className="mt-4 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-1" data-id="element-31" data-mp="ldcgm4fut9ev">
              {bonusTools.map(tool => <li key={tool} className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-32" data-mp="gft00xvookjr">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" strokeWidth={3} aria-hidden="true" data-id="element-33" data-mp="qcfijg0jezim" />
                  {tool}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-sm font-medium text-brand-cyan sm:text-base" data-id="element-34" data-mp="1e29vdxkuwo2v">
          Simple tools that turn completed pages into visible progress.
        </p>
      </div>
    </section>;
}